import { IAdminIngredient } from '@interfaces/lookups';

export const isOptionEqualToValue = (item: IAdminIngredient, value: IAdminIngredient): boolean =>
  item.name === value.name;
